var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"usc-listImg gutter-lg mb body"},[_c('div',{staticClass:"usc-listImg__col"},[_vm._t("title"),_vm._v(" "),_vm._t("body"),_vm._v(" "),_c('ul',[_vm._t("item")],2)],2),_vm._v(" "),_c('div',{staticClass:"usc-listImg__col usc-listImg__col--pd"},[_vm._t("img")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4e2f2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListImage.vue
// module id = null
// module chunks = 